export const ADD_LIST_FOOD = 'ADD_LIST_FOOD';
export const ADD_FOOD = 'ADD_FOOD';
export const UPDATE_FOOD = 'UPDATE_FOOD';